// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   Container,
//   InputGroup,
//   Form,
//   Button,
//   Card,
//   Nav,
//   Row,
//   Col,
//   Dropdown,
//   Spinner
// } from "react-bootstrap";
// import { Search, Grid3x3, List } from "react-bootstrap-icons";
// import CreateGroupForm from "../Components/GroupPageSection/CreateGroupForm";
// import Header from "../Components/Header";
// import Swal from "sweetalert2";
// // import CreateGroupPage2 from "./CreateGroupPage2";

// export default function GroupsPage2() {
//   const [activeTab, setActiveTab] = useState("all");
//   const [viewMode, setViewMode] = useState("grid");
//   const [sortBy, setSortBy] = useState("Most Members");
//   const [groups, setGroups] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const token = localStorage.getItem("jwttoken");

//   useEffect(() => {
//     setLoading(true);
//     axios
//       .get("https://kaasbackend.vetrinahealthcare.com/socialapp/groups/", {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         let fetchedGroups = response.data;

//         // Sort groups by most members FIRST
//         fetchedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));

//         setGroups(fetchedGroups);
//       })
//       .catch((error) => {
//         console.error("Error fetching groups:", error);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [token]); // Runs only when token changes

//   useEffect(() => {
//     let sortedGroups = [...groups];

//     if (sortBy === "Recently Active") {
//       sortedGroups.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
//     } else if (sortBy === "Most Members") {
//       sortedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));
//     } else if (sortBy === "Alphabetical") {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name));
//     }

//     setGroups(sortedGroups);
//   }, [sortBy]); // Sorts when the user changes sorting

//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`);
//   };

// //   const handleGroupClick = () => {
// //     navigate('/create-group-page2');
// // };

// // const handleJoinGroup = (groupId) => {
// //   axios.post(
// //     `https://kaasbackend.vetrinahealthcare.com/socialapp/groups/${groupId}/join/`,
// //     {},
// //     { headers: { Authorization: `Bearer ${token}` } }
// //   )
// //   .then(() => {
// //     console.log("Joined group successfully!");
// //   })
// //   .catch((error) => {
// //     console.error("Error joining group:", error);
// //   });
// // };
// const [pendingJoinRequests, setPendingJoinRequests] = useState([]);

//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: "info",
//         title: "You're already a member!",
//         text: "You have already joined this group.",
//       });
//       return;
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]); // Set to pending

//     axios
//       .post(
//         `https://kaasbackend.vetrinahealthcare.com/socialapp/groups/${groupId}/join/`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       .then(() => {
//         Swal.fire({
//           icon: "success",
//           title: "Join Request Submitted!",
//           text: "Your request has been sent. Waiting for approval.",
//         });

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) =>
//             group.id === groupId
//               ? { ...group, is_pending: true }
//               : group
//           )
//         );
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)); // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: "info",
//             title: "You're already a member!",
//             text: "You have already joined this group.",
//           });
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Something went wrong while joining the group.",
//           });
//         }
//         console.error("Error joining group:", error);
//       });
//   };

// const backendURL = "https://kaasbackend.vetrinahealthcare.com";

//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//         transition: "transform 0.3s ease-in-out",
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className="position-relative">
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo
//                   .split("/")
//                   .pop()}`
//               : "https://placehold.co/400x200?text=Group+Cover&font=roboto" // Default placeholder
//           }
//           alt="Group Cover"
//           className="w-100"
//           style={{ height: "220px", objectFit: "cover", borderRadius: "20px" }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className="position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white"
//           style={{
//             fontSize: "12px",
//             background: "rgba(0, 0, 0, 0.6)",
//             backdropFilter: "blur(5px)",
//             textTransform: "uppercase",
//           }}
//         >
//           {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white"
//           style={{
//             background:
//               "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)",
//           }}
//         >
//           <h3
//             className="h5 fw-bold mb-1 text-truncate"
//             onClick={(e) => {
//               e.stopPropagation();
//               handleGroupClick(group.id);
//             }}
//             style={{ cursor: "pointer", maxWidth: "90%" }}
//           >
//             {group.name || "Unnamed Group"}
//           </h3>
//           <p className="small mb-0">
//             Created by {group.created_by?.first_name || "Unknown"}{" "}
//             {group.created_by?.last_name || ""}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <p
//           className="text-muted text-truncate"
//           style={{ minHeight: "50px", fontSize: "14px" }}
//         >
//           {group.description || "No description available."}
//         </p>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <span
//             className="text-muted fw-semibold"
//             style={{ color: "#B8529E", fontSize: "1.2rem" }}
//           >
//             👥 {group.members?.length || 0} Members
//           </span>
//           {/* <Button
//             variant="primary"
//             size="sm"
//             className="rounded-pill px-4 shadow-sm"
//             style={{
//               background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",

//               border: "none",
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               handleJoinGroup(group.id);
//             }}
//           >
//             Join
//           </Button> */}
//             <Button
//       variant={
//         group.is_connected
//           ? "secondary"
//           : group.is_pending
//           ? "warning"
//           : "primary"
//       }
//       size="sm"
//       className="rounded-pill px-4 shadow-sm"
//       style={{
//         background: group.is_connected
//           ? "gray"
//           : group.is_pending
//           ? "orange"
//           : "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//         border: "none",
//       }}
//       disabled={group.is_connected || group.is_pending}
//       onClick={(e) => {
//         e.stopPropagation();
//         handleJoinGroup(group.id, group.is_connected);
//       }}
//     >
//       {group.is_connected ? "Joined" : group.is_pending ? "Pending" : "Join"}
//     </Button>

//         </div>
//       </Card.Body>
//     </Card>
//   );

//   if (activeTab === "create") {
//     return <CreateGroupForm />;
//   }

//   return (
//     <>
//       <Header />
//       <Container className="py-4">
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h1 className="fw-bold">Groups</h1>
//           <InputGroup style={{ width: "300px" }}>
//             <InputGroup.Text className="bg-white border-end-0">
//               <Search />
//             </InputGroup.Text>
//             <Form.Control placeholder="Search Groups..." className="border-start-0" style={{ boxShadow: "none" }} />
//           </InputGroup>
//         </div>
//         <Nav className="mb-4">
//   {["all", "my", "create"].map((tab) => (
//     <Nav.Item key={tab}>
//       <Nav.Link
//         onClick={() => setActiveTab(tab)}
//         style={{
//           backgroundColor: activeTab === tab ? "#B8529E" : "transparent",
//           color: activeTab === tab ? "white" : "#6c757d",
//           borderRadius: "50px",
//           padding: "8px 16px",
//           transition: "background-color 0.3s ease",
//         }}
//       >
//         {tab === "all" ? "All Groups" : tab === "my" ? "My Groups" : "Create a Group"}
//       </Nav.Link>
//     </Nav.Item>
//   ))}
// </Nav>

//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <p className="text-muted mb-0">Showing {groups.length} groups</p>
//           <div className="d-flex gap-2">
//             <Dropdown>
//               <Dropdown.Toggle variant="outline-secondary" className="d-flex align-items-center gap-2">
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {["Recently Active", "Most Members", "Alphabetical"].map((option) => (
//                   <Dropdown.Item key={option} onClick={() => setSortBy(option)}>
//                     {option}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className="btn-group">
//   <Button
//     style={{
//       backgroundColor: viewMode === "grid" ? "#B8529E" : "transparent",
//       borderColor: "#B8529E",
//       color: viewMode === "grid" ? "white" : "#B8529E",
//     }}
//     onClick={() => setViewMode("grid")}
//     className="d-flex align-items-center justify-content-center"
//   >
//     <Grid3x3 />
//   </Button>

//   <Button
//     style={{
//       backgroundColor: viewMode === "list" ? "#B8529E" : "transparent",
//       borderColor: "#B8529E",
//       color: viewMode === "list" ? "white" : "#B8529E",
//     }}
//     onClick={() => setViewMode("list")}
//     className="d-flex align-items-center justify-content-center"
//   >
//     <List />
//   </Button>
// </div>

//           </div>
//         </div>
//         {loading ? ( // ⬅️ Show spinner while loading
//           <div className="text-center my-5">
//             <Spinner animation="border" variant="primary" />
//             <p className="mt-2">Loading groups...</p>
//           </div>
//         ) : (
//         <Row>
//           {groups.length > 0 ? (
//             groups.map((group) => (
//               <Col md={6} lg={4} className="mb-4" key={group.id}>
//                 {renderGroupCard(group)}
//               </Col>
//             ))
//           ) : (
//             <p className="text-center text-muted">No groups found.</p>
//           )}

//         </Row>
//            )}
//       </Container>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   Container,
//   InputGroup,
//   Form,
//   Button,
//   Card,
//   Nav,
//   Row,
//   Col,
//   Dropdown,
//   Spinner
// } from "react-bootstrap";
// import { Search, Grid3x3, List } from "react-bootstrap-icons";
// import CreateGroupForm from "../Components/GroupPageSection/CreateGroupForm";
// import Header from "../Components/Header";
// import Swal from "sweetalert2";
// // import CreateGroupPage2 from "./CreateGroupPage2";

// export default function GroupsPage2() {
//   const [activeTab, setActiveTab] = useState("all");
//   const [viewMode, setViewMode] = useState("grid");
//   const [sortBy, setSortBy] = useState("Most Members");
//   const [groups, setGroups] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const token = localStorage.getItem("jwttoken");

//   useEffect(() => {
//     setLoading(true);
//     axios
//       .get("https://kaasbackend.vetrinahealthcare.com/socialapp/groups/", {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         let fetchedGroups = response.data;

//         // Sort groups by most members FIRST
//         fetchedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));

//         setGroups(fetchedGroups);
//       })
//       .catch((error) => {
//         console.error("Error fetching groups:", error);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [token]); // Runs only when token changes

//   useEffect(() => {
//     let sortedGroups = [...groups];

//     if (sortBy === "Recently Active") {
//       sortedGroups.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
//     } else if (sortBy === "Most Members") {
//       sortedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));
//     } else if (sortBy === "Alphabetical") {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name));
//     }

//     setGroups(sortedGroups);
//   }, [sortBy]); // Sorts when the user changes sorting

//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`);
//   };

// //   const handleGroupClick = () => {
// //     navigate('/create-group-page2');
// // };

// // const handleJoinGroup = (groupId) => {
// //   axios.post(
// //     `https://kaasbackend.vetrinahealthcare.com/socialapp/groups/${groupId}/join/`,
// //     {},
// //     { headers: { Authorization: `Bearer ${token}` } }
// //   )
// //   .then(() => {
// //     console.log("Joined group successfully!");
// //   })
// //   .catch((error) => {
// //     console.error("Error joining group:", error);
// //   });
// // };
// const [pendingJoinRequests, setPendingJoinRequests] = useState([]);

//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: "info",
//         title: "You're already a member!",
//         text: "You have already joined this group.",
//       });
//       return;
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]); // Set to pending

//     axios
//       .post(
//         `https://kaasbackend.vetrinahealthcare.com/socialapp/groups/${groupId}/join/`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       .then(() => {
//         Swal.fire({
//           icon: "success",
//           title: "Join Request Submitted!",
//           text: "Your request has been sent. Waiting for approval.",
//         });

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) =>
//             group.id === groupId
//               ? { ...group, is_pending: true }
//               : group
//           )
//         );
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)); // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: "info",
//             title: "You're already a member!",
//             text: "You have already joined this group.",
//           });
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Something went wrong while joining the group.",
//           });
//         }
//         console.error("Error joining group:", error);
//       });
//   };

// const backendURL = "https://kaasbackend.vetrinahealthcare.com";

//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//         transition: "transform 0.3s ease-in-out",
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className="position-relative">
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo
//                   .split("/")
//                   .pop()}`
//               : "https://placehold.co/400x200?text=Group+Cover&font=roboto" // Default placeholder
//           }
//           alt="Group Cover"
//           className="w-100"
//           style={{ height: "220px", objectFit: "cover", borderRadius: "20px" }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className="position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white"
//           style={{
//             fontSize: "12px",
//             background: "rgba(0, 0, 0, 0.6)",
//             backdropFilter: "blur(5px)",
//             textTransform: "uppercase",
//           }}
//         >
//           {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white"
//           style={{
//             background:
//               "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)",
//           }}
//         >
//           <h3
//             className="h5 fw-bold mb-1 text-truncate"
//             onClick={(e) => {
//               e.stopPropagation();
//               handleGroupClick(group.id);
//             }}
//             style={{ cursor: "pointer", maxWidth: "90%" }}
//           >
//             {group.name || "Unnamed Group"}
//           </h3>
//           <p className="small mb-0">
//             Created by {group.created_by?.first_name || "Unknown"}{" "}
//             {group.created_by?.last_name || ""}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <p
//           className="text-muted text-truncate"
//           style={{ minHeight: "50px", fontSize: "14px" }}
//         >
//           {group.description || "No description available."}
//         </p>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <span
//             className="text-muted fw-semibold"
//             style={{ color: "#B8529E", fontSize: "1.2rem" }}
//           >
//             👥 {group.members?.length || 0} Members
//           </span>
//           {/* <Button
//             variant="primary"
//             size="sm"
//             className="rounded-pill px-4 shadow-sm"
//             style={{
//               background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",

//               border: "none",
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               handleJoinGroup(group.id);
//             }}
//           >
//             Join
//           </Button> */}
//             <Button
//       variant={
//         group.is_connected
//           ? "secondary"
//           : group.is_pending
//           ? "warning"
//           : "primary"
//       }
//       size="sm"
//       className="rounded-pill px-4 shadow-sm"
//       style={{
//         background: group.is_connected
//           ? "gray"
//           : group.is_pending
//           ? "orange"
//           : "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//         border: "none",
//       }}
//       disabled={group.is_connected || group.is_pending}
//       onClick={(e) => {
//         e.stopPropagation();
//         handleJoinGroup(group.id, group.is_connected);
//       }}
//     >
//       {group.is_connected ? "Joined" : group.is_pending ? "Pending" : "Join"}
//     </Button>

//         </div>
//       </Card.Body>
//     </Card>
//   );

//   // if (activeTab === "create") {
//   //   return <CreateGroupForm />;
//   // }

//   return (
//     <>
//       <Header />
//       <Container className="py-4">
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h1 className="fw-bold">Groups</h1>
//           <InputGroup style={{ width: "300px" }}>
//             <InputGroup.Text className="bg-white border-end-0">
//               <Search />
//             </InputGroup.Text>
//             <Form.Control placeholder="Search Groups..." className="border-start-0" style={{ boxShadow: "none" }} />
//           </InputGroup>
//         </div>
//         <Nav className="mb-4">
//   {["all", "my" /*, "create" */].map((tab) => (
//     <Nav.Item key={tab}>
//       <Nav.Link
//         onClick={() => setActiveTab(tab)}
//         style={{
//           backgroundColor: activeTab === tab ? "#B8529E" : "transparent",
//           color: activeTab === tab ? "white" : "#6c757d",
//           borderRadius: "50px",
//           padding: "8px 16px",
//           transition: "background-color 0.3s ease",
//         }}
//       >
//         {tab === "all" ? "All Groups" : tab === "my" ? "My Groups": "" /*: "Create a Group"*/}
//       </Nav.Link>
//     </Nav.Item>
//   ))}
// </Nav>

//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <p className="text-muted mb-0">Showing {groups.length} groups</p>
//           <div className="d-flex gap-2">
//             <Dropdown>
//               <Dropdown.Toggle variant="outline-secondary" className="d-flex align-items-center gap-2">
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {["Recently Active", "Most Members", "Alphabetical"].map((option) => (
//                   <Dropdown.Item key={option} onClick={() => setSortBy(option)}>
//                     {option}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className="btn-group">
//   <Button
//     style={{
//       backgroundColor: viewMode === "grid" ? "#B8529E" : "transparent",
//       borderColor: "#B8529E",
//       color: viewMode === "grid" ? "white" : "#B8529E",
//     }}
//     onClick={() => setViewMode("grid")}
//     className="d-flex align-items-center justify-content-center"
//   >
//     <Grid3x3 />
//   </Button>

//   <Button
//     style={{
//       backgroundColor: viewMode === "list" ? "#B8529E" : "transparent",
//       borderColor: "#B8529E",
//       color: viewMode === "list" ? "white" : "#B8529E",
//     }}
//     onClick={() => setViewMode("list")}
//     className="d-flex align-items-center justify-content-center"
//   >
//     <List />
//   </Button>
// </div>

//           </div>
//         </div>
//         {loading ? ( // ⬅️ Show spinner while loading
//           <div className="text-center my-5">
//             <Spinner animation="border" variant="primary" />
//             <p className="mt-2">Loading groups...</p>
//           </div>
//         ) : (
//         <Row>
//           {groups.length > 0 ? (
//             groups.map((group) => (
//               <Col md={6} lg={4} className="mb-4" key={group.id}>
//                 {renderGroupCard(group)}
//               </Col>
//             ))
//           ) : (
//             <p className="text-center text-muted">No groups found.</p>
//           )}

//         </Row>
//            )}
//       </Container>
//     </>
//   );
// }

// import React, { useState, useEffect } from 'react'
// import axios from 'axios'
// import { useNavigate } from 'react-router-dom'
// import {
//   Container,
//   InputGroup,
//   Form,
//   Button,
//   Card,
//   Nav,
//   Row,
//   Col,
//   Dropdown,
//   Spinner,
// } from 'react-bootstrap'
// import { Search, Grid3x3, List } from 'react-bootstrap-icons'
// import CreateGroupForm from '../Components/GroupPageSection/CreateGroupForm'
// import Header from '../Components/Header'
// import Swal from 'sweetalert2'
// import CreateGroupPage2 from './CreateGroupPage2'

// export default function GroupsPage2() {
//   const [activeTab, setActiveTab] = useState('all')
//   const [viewMode, setViewMode] = useState('grid')
//   const [sortBy, setSortBy] = useState('Most Members')
//   const [groups, setGroups] = useState([])
//   const [loading, setLoading] = useState(true)
//   const navigate = useNavigate()
//   const token = localStorage.getItem('jwttoken')

//   useEffect(() => {
//     setLoading(true)
//     axios
//       .get('https://kaasbackend.vetrinahealthcare.com/socialapp/groups/', {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         let fetchedGroups = response.data

//         // Sort groups by most members FIRST
//         fetchedGroups.sort(
//           (a, b) => (b.members?.length || 0) - (a.members?.length || 0)
//         )

//         setGroups(fetchedGroups)
//       })
//       .catch((error) => {
//         console.error('Error fetching groups:', error)
//       })
//       .finally(() => {
//         setLoading(false)
//       })
//   }, [token]) // Runs only when token changes

//   useEffect(() => {
//     let sortedGroups = [...groups]

//     if (sortBy === 'Recently Active') {
//       sortedGroups.sort(
//         (a, b) => new Date(b.created_at) - new Date(a.created_at)
//       )
//     } else if (sortBy === 'Most Members') {
//       sortedGroups.sort(
//         (a, b) => (b.members?.length || 0) - (a.members?.length || 0)
//       )
//     } else if (sortBy === 'Alphabetical') {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name))
//     }

//     setGroups(sortedGroups)
//   }, [sortBy]) // Sorts when the user changes sorting

//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`)
//   }

//   const handleCreateGroupClick = () => {
//     navigate('/create-group-page2')
//   }

//   const [pendingJoinRequests, setPendingJoinRequests] = useState([])

//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: 'info',
//         title: "You're already a member!",
//         text: 'You have already joined this group.',
//       })
//       return
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]) // Set to pending

//     axios
//       .post(
//         `https://kaasbackend.vetrinahealthcare.com/socialapp/groups/${groupId}/join/`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       .then(() => {
//         Swal.fire({
//           icon: 'success',
//           title: 'Join Request Submitted!',
//           text: 'Your request has been sent. Waiting for approval.',
//         })

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) =>
//             group.id === groupId ? { ...group, is_pending: true } : group
//           )
//         )
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)) // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: 'info',
//             title: "You're already a member!",
//             text: 'You have already joined this group.',
//           })
//         } else {
//           Swal.fire({
//             icon: 'error',
//             title: 'Error!',
//             text: 'Something went wrong while joining the group.',
//           })
//         }
//         console.error('Error joining group:', error)
//       })
//   }

//   const backendURL = 'https://kaasbackend.vetrinahealthcare.com'

//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className='h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform'
//       style={{
//         background: '#fff',
//         borderRadius: '20px',
//         transition: 'transform 0.3s ease-in-out',
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className='position-relative'>
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo
//                   .split('/')
//                   .pop()}`
//               : 'https://placehold.co/400x200?text=Group+Cover&font=roboto' // Default placeholder
//           }
//           alt='Group Cover'
//           className='w-100'
//           style={{ height: '220px', objectFit: 'cover', borderRadius: '20px' }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className='position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white'
//           style={{
//             fontSize: '12px',
//             background: 'rgba(0, 0, 0, 0.6)',
//             backdropFilter: 'blur(5px)',
//             textTransform: 'uppercase',
//           }}
//         >
//           {group.privacy === 'public' ? '🌍 Public' : '🔒 Private'}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className='position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white'
//           style={{
//             background:
//               'linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)',
//           }}
//         >
//           <h3
//             className='h5 fw-bold mb-1 text-truncate'
//             onClick={(e) => {
//               e.stopPropagation()
//               handleGroupClick(group.id)
//             }}
//             style={{ cursor: 'pointer', maxWidth: '90%' }}
//           >
//             {group.name || 'Unnamed Group'}
//           </h3>
//           <p className='small mb-0'>
//             Created by {group.created_by?.first_name || 'Unknown'}{' '}
//             {group.created_by?.last_name || ''}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className='p-4'>
//         <p
//           className='text-muted text-truncate'
//           style={{ minHeight: '50px', fontSize: '14px' }}
//         >
//           {group.description || 'No description available.'}
//         </p>

//         {/* Members & Join Button */}
//         <div className='d-flex justify-content-between align-items-center'>
//           <span
//             className='text-muted fw-semibold'
//             style={{ color: '#B8529E', fontSize: '1.2rem' }}
//           >
//             👥 {group.members?.length || 0} Members
//           </span>
//           <Button
//             variant={
//               group.is_connected
//                 ? 'secondary'
//                 : group.is_pending
//                 ? 'warning'
//                 : 'primary'
//             }
//             size='sm'
//             className='rounded-pill px-4 shadow-sm'
//             style={{
//               background: group.is_connected
//                 ? 'gray'
//                 : group.is_pending
//                 ? 'orange'
//                 : 'linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)',
//               border: 'none',
//             }}
//             disabled={group.is_connected || group.is_pending}
//             onClick={(e) => {
//               e.stopPropagation()
//               handleJoinGroup(group.id, group.is_connected)
//             }}
//           >
//             {group.is_connected
//               ? 'Joined'
//               : group.is_pending
//               ? 'Pending'
//               : 'Join'}
//           </Button>
//         </div>
//       </Card.Body>
//     </Card>
//   )

//   if (activeTab === 'create') {
//     return <CreateGroupPage2 />
//   }

//   return (
//     <>
//       <Header />
//       <Container className='py-4' >
//       <div className='d-flex justify-content-between align-items-center mb-4' style={{ marginTop: '3.5rem' }}>  
//                 <h1 className='fw-bold'>Groups</h1>
//           <InputGroup style={{ width: '300px' }}>
//             <InputGroup.Text className='bg-white border-end-0'>
//               <Search />
//             </InputGroup.Text>
//             <Form.Control
//               placeholder='Search Groups...'
//               className='border-start-0'
//               style={{ boxShadow: 'none' }}
//             />
//           </InputGroup>
//         </div>
//         <Nav className='mb-4'>
//           {['all', 'my','create'].map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 style={{
//                   backgroundColor:
//                     activeTab === tab ? '#B8529E' : 'transparent',
//                   color: activeTab === tab ? 'white' : '#6c757d',
//                   borderRadius: '50px',
//                   padding: '8px 16px',
//                   transition: 'background-color 0.3s ease',
//                 }}
//               >
// {tab === 'all'
//   ? 'All Groups'
//   : tab === 'my'
//   ? 'My Groups'
//   : tab === 'create'
//   ? 'Create a Group'
//   : ''}
//                 {/* {{
//                   all: 'All Groups',
//                   my: 'My Groups',
//                 }[tab] || ''} */}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//         </Nav>

//         <div className='d-flex justify-content-between align-items-center mb-4'>
//           <p className='text-muted mb-0'>Showing {groups.length} groups</p>
//           <div className='d-flex gap-2'>
//             <Dropdown>
//               <Dropdown.Toggle
//                 variant='outline-secondary'
//                 className='d-flex align-items-center gap-2'
//               >
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {['Recently Active', 'Most Members', 'Alphabetical'].map(
//                   (option) => (
//                     <Dropdown.Item
//                       key={option}
//                       onClick={() => setSortBy(option)}
//                     >
//                       {option}
//                     </Dropdown.Item>
//                   )
//                 )}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className='btn-group'>
//               <Button
//                 style={{
//                   backgroundColor:
//                     viewMode === 'grid' ? '#B8529E' : 'transparent',
//                   borderColor: '#B8529E',
//                   color: viewMode === 'grid' ? 'white' : '#B8529E',
//                 }}
//                 onClick={() => setViewMode('grid')}
//                 className='d-flex align-items-center justify-content-center'
//               >
//                 <Grid3x3 />
//               </Button>

//               <Button
//                 style={{
//                   backgroundColor:
//                     viewMode === 'list' ? '#B8529E' : 'transparent',
//                   borderColor: '#B8529E',
//                   color: viewMode === 'list' ? 'white' : '#B8529E',
//                 }}
//                 onClick={() => setViewMode('list')}
//                 className='d-flex align-items-center justify-content-center'
//               >
//                 <List />
//               </Button>
//             </div>
//           </div>
//         </div>
//         {loading ? (
//           <div className='text-center my-5'>
//             <Spinner animation='border' variant='primary' />
//             <p className='mt-2'>Loading groups...</p>
//           </div>
//         ) : (
//           <Row>
//             {groups.length > 0 ? (
//               groups.map((group) => (
//                 <Col md={6} lg={4} className='mb-4' key={group.id}>
//                   {renderGroupCard(group)}
//                 </Col>
//               ))
//             ) : (
//               <div className='col-12 text-center py-5'>
//                 <img
//                   src='https://cdn-icons-png.flaticon.com/512/4076/4076478.png'
//                   alt='No groups'
//                   style={{ width: '150px', opacity: 0.7, marginBottom: '20px' }}
//                 />
//                 <h4 className='text-muted'>No groups found</h4>
//                 <p className='text-muted mb-4'>
//                   Be the first to create a group!
//                 </p>
//                 <Button
//                   variant='primary'
//                   onClick={handleCreateGroupClick}
//                   style={{
//                     background:
//                       'linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)',
//                     border: 'none',
//                     padding: '10px 25px',
//                     borderRadius: '25px',
//                     fontWeight: '500',
//                   }}
//                 >
//                   Create Group
//                 </Button>
//               </div>
//             )}
//           </Row>
//         )}
//       </Container>
//     </>
//   )
// }
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import {
//   Container,
//   InputGroup,
//   Form,
//   Button,
//   Card,
//   Nav,
//   Row,
//   Col,
//   Dropdown,
//   Spinner,
//   Modal
// } from 'react-bootstrap';
// import CreateGroupPage2 from './CreateGroupPage2'
// import { Search, Grid3x3, List } from 'react-bootstrap-icons';
// import Swal from 'sweetalert2';
// import Header from '../Components/Header'
// // Main component
// function GroupsPage() {
//   const [activeTab, setActiveTab] = useState('all');
//   const [viewMode, setViewMode] = useState('grid');
//   const [sortBy, setSortBy] = useState('Most Members');
//   const [groups, setGroups] = useState([]);
//   const [myGroups, setMyGroups] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [pendingJoinRequests, setPendingJoinRequests] = useState([]);
  
//   // Form state for creating a group
//   const [newGroup, setNewGroup] = useState({
//     name: '',
//     description: '',
//     privacy: 'public',
//     is_active: true,
//     post_permission: 'admin_only',
//     invite_permission: 'user'
//   });

//   const navigate = useNavigate();
//   const token = localStorage.getItem('jwttoken');
//   const backendURL = 'https://kaasbackend.vetrinahealthcare.com';

//   // Fetch all groups
//   useEffect(() => {
//     if (activeTab === 'all') {
//       setLoading(true);
//       axios
//         .get(`${backendURL}/socialapp/groups/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           let fetchedGroups = response.data;
//           // Sort groups by most members first
//           fetchedGroups.sort(
//             (a, b) => (b.members?.length || 0) - (a.members?.length || 0)
//           );
//           setGroups(fetchedGroups);
//         })
//         .catch((error) => {
//           console.error('Error fetching groups:', error);
//           Swal.fire({
//             icon: 'error',
//             title: 'Error!',
//             text: 'Failed to load groups. Please try again later.',
//           });
//         })
//         .finally(() => {
//           setLoading(false);
//         });
//     }
//   }, [token, activeTab]);

//   // Fetch my groups
//   useEffect(() => {
//     if (activeTab === 'my') {
//       setLoading(true);
//       axios
//         .get(`${backendURL}/socialapp/group_memberships/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           const memberships = response.data;
          
//           // Get the group details for each membership
//           const groupPromises = memberships.map(membership => 
//             axios.get(`${backendURL}/socialapp/groups/${membership.group}/`, {
//               headers: { Authorization: `Bearer ${token}` },
//             })
//           );
          
//           Promise.all(groupPromises)
//             .then(groupResponses => {
//               const myGroupsData = groupResponses.map(res => ({
//                 ...res.data,
//                 is_connected: true // Mark as already joined
//               }));
              
//               // Sort by the selected criteria
//               sortGroups(myGroupsData, sortBy);
//               setMyGroups(myGroupsData);
//             })
//             .catch(error => {
//               console.error('Error fetching group details:', error);
//             })
//             .finally(() => {
//               setLoading(false);
//             });
//         })
//         .catch((error) => {
//           console.error('Error fetching group memberships:', error);
//           setLoading(false);
//         });
//     }
//   }, [token, activeTab]);

//   // Sort groups when sort criteria changes
//   useEffect(() => {
//     if (activeTab === 'all') {
//       sortGroups([...groups], sortBy);
//     } else if (activeTab === 'my') {
//       sortGroups([...myGroups], sortBy);
//     }
//   }, [sortBy]);

//   // Function to sort groups based on criteria
//   const sortGroups = (groupsToSort, criteria) => {
//     let sortedGroups = [...groupsToSort];

//     if (criteria === 'Recently Active') {
//       sortedGroups.sort(
//         (a, b) => new Date(b.created_at) - new Date(a.created_at)
//       );
//     } else if (criteria === 'Most Members') {
//       sortedGroups.sort(
//         (a, b) => (b.members?.length || 0) - (a.members?.length || 0)
//       );
//     } else if (criteria === 'Alphabetical') {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name));
//     }

//     if (activeTab === 'all') {
//       setGroups(sortedGroups);
//     } else if (activeTab === 'my') {
//       setMyGroups(sortedGroups);
//     }
//   };

//   // Handle group click to navigate to group details
//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`);
//   };

//   // Handle joining a group
//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: 'info',
//         title: "You're already a member!",
//         text: 'You have already joined this group.',
//       });
//       return;
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]); // Set to pending

//     axios
//       .post(
//         `${backendURL}/socialapp/groups/${groupId}/join/`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       .then(() => {
//         Swal.fire({
//           icon: 'success',
//           title: 'Join Request Submitted!',
//           text: 'Your request has been sent. Waiting for approval.',
//         });

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) =>
//             group.id === groupId ? { ...group, is_pending: true } : group
//           )
//         );
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)); // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: 'info',
//             title: "You're already a member!",
//             text: 'You have already joined this group.',
//           });
//         } else {
//           Swal.fire({
//             icon: 'error',
//             title: 'Error!',
//             text: 'Something went wrong while joining the group.',
//           });
//         }
//         console.error('Error joining group:', error);
//       });
//   };

//   // Handle input change for create group form
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewGroup({
//       ...newGroup,
//       [name]: value
//     });
//   };

//   // Handle select change for create group form
//   const handleSelectChange = (e) => {
//     const { name, value } = e.target;
//     setNewGroup({
//       ...newGroup,
//       [name]: value
//     });
//   };

//   // Create a new group
//   const handleCreateGroup = (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Get user info from localStorage or another source
//     const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {
//       first_name: "User",
//       last_name: "Name",
//       email: "user@example.com",
//       profile_pic: ""
//     };

//     const payload = {
//       created_by: {
//         first_name: userInfo.first_name,
//         last_name: userInfo.last_name,
//         email: userInfo.email,
//         profile_pic: userInfo.profile_pic || ""
//       },
//       ...newGroup
//     };

//     axios.post(`${backendURL}/socialapp/groups/`, payload, {
//       headers: { Authorization: `Bearer ${token}` }
//     })
//     .then(response => {
//       Swal.fire({
//         icon: 'success',
//         title: 'Group Created!',
//         text: 'Your group has been created successfully.',
//       });
      
//       // Add the new group to the groups list
//       setGroups(prevGroups => [response.data, ...prevGroups]);
      
//       // Reset form and close modal
//       setNewGroup({
//         name: '',
//         description: '',
//         privacy: 'public',
//         is_active: true,
//         post_permission: 'admin_only',
//         invite_permission: 'user'
//       });
//       setShowCreateModal(false);
      
//       // Switch to all groups tab to see the new group
//       setActiveTab('all');
//     })
//     .catch(error => {
//       console.error('Error creating group:', error);
//       Swal.fire({
//         icon: 'error',
//         title: 'Error!',
//         text: 'Failed to create group. Please try again.',
//       });
//     })
//     .finally(() => {
//       setLoading(false);
//     });
//   };

//   // Filter groups based on search term
//   const filteredGroups = activeTab === 'all' 
//     ? groups.filter(group => 
//         group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         group.description.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     : myGroups.filter(group => 
//         group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         group.description.toLowerCase().includes(searchTerm.toLowerCase())
//       );

//   // Render a group card
//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className='h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform'
//       style={{
//         background: '#fff',
//         borderRadius: '20px',
//         transition: 'transform 0.3s ease-in-out',
//         cursor: 'pointer'
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className='position-relative'>
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo
//                   .split('/')
//                   .pop()}`
//               : 'https://placehold.co/400x200?text=Group+Cover&font=roboto' // Default placeholder
//           }
//           alt='Group Cover'
//           className="img-fluid w-100 bg-light"
//           style={{
//             height: '220px',
//             objectFit: 'contain', // ⬅️ Ensures full image is visible
//             borderTopLeftRadius: '20px',
//             borderTopRightRadius: '20px',
//             backgroundColor: '#f0f0f0', // optional fallback for transparency
//           }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className='position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white'
//           style={{
//             fontSize: '12px',
//             background: 'rgba(0, 0, 0, 0.6)',
//             backdropFilter: 'blur(5px)',
//             textTransform: 'uppercase',
//           }}
//         >
//           {group.privacy === 'public' ? '🌍 Public' : '🔒 Private'}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className='position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white'
//           style={{
//             background:
//               'linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)',
//           }}
//         >
//           <h3
//             className='h5 fw-bold mb-1 text-truncate'
//             onClick={(e) => {
//               e.stopPropagation();
//               handleGroupClick(group.id);
//             }}
//             style={{ cursor: 'pointer', maxWidth: '90%' }}
//           >
//             {group.name || 'Unnamed Group'}
//           </h3>
//           <p className='small mb-0'>
//             Created by {group.created_by?.first_name || 'Unknown'}{' '}
//             {group.created_by?.last_name || ''}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className='p-4'>
//         <p
//           className='text-muted text-truncate'
//           style={{ minHeight: '50px', fontSize: '14px' }}
//         >
//           {group.description || 'No description available.'}
//         </p>

//         {/* Members & Join Button */}
//         <div className='d-flex justify-content-between align-items-center'>
//           <span
//             className='text-muted fw-semibold'
//             style={{ color: '#B8529E', fontSize: '1.2rem' }}
//           >
//             👥 {group.members?.length || 0} Members
//           </span>
//           {activeTab === 'all' && (
//             <Button
//               variant={
//                 group.is_connected
//                   ? 'secondary'
//                   : group.is_pending
//                   ? 'warning'
//                   : 'primary'
//               }
//               size='sm'
//               className='rounded-pill px-4 shadow-sm'
//               style={{
//                 background: group.is_connected
//                   ? 'gray'
//                   : group.is_pending
//                   ? 'orange'
//                   : 'linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)',
//                 border: 'none',
//               }}
//               disabled={group.is_connected || group.is_pending}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleJoinGroup(group.id, group.is_connected);
//               }}
//             >
//               {group.is_connected
//                 ? 'Joined'
//                 : group.is_pending
//                 ? 'Pending'
//                 : 'Join'}
//             </Button>
//           )}
//         </div>
//       </Card.Body>
//     </Card>
//   );

//   // Create Group Modal
//   const renderCreateGroupModal = () => (
//     <Modal 
//       show={showCreateModal} 
//       onHide={() => setShowCreateModal(false)}
//       centered
//       size="lg"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>Create a New Group</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form onSubmit={handleCreateGroup}>
//           <Form.Group className="mb-3">
//             <Form.Label>Group Name*</Form.Label>
//             <Form.Control
//               type="text"
//               name="name"
//               value={newGroup.name}
//               onChange={handleInputChange}
//               placeholder="Enter group name"
//               required
//             />
//           </Form.Group>
          
//           <Form.Group className="mb-3">
//             <Form.Label>Description</Form.Label>
//             <Form.Control
//               as="textarea"
//               name="description"
//               value={newGroup.description}
//               onChange={handleInputChange}
//               placeholder="Describe your group"
//               rows={3}
//             />
//           </Form.Group>
          
//           <Row className="mb-3">
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Privacy</Form.Label>
//                 <Form.Select 
//                   name="privacy" 
//                   value={newGroup.privacy}
//                   onChange={handleSelectChange}
//                 >
//                   <option value="public">Public</option>
//                   <option value="private">Private</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">
//                   {newGroup.privacy === 'public' 
//                     ? 'Anyone can see who\'s in the group and what they post.' 
//                     : 'Only members can see who\'s in the group and what they post.'}
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Post Permission</Form.Label>
//                 <Form.Select 
//                   name="post_permission" 
//                   value={newGroup.post_permission}
//                   onChange={handleSelectChange}
//                 >
//                   <option value="admin_only">Admin Only</option>
//                   <option value="all_members">All Members</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">
//                   Who can post content in this group
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//           </Row>
          
//           <Form.Group className="mb-3">
//             <Form.Label>Invite Permission</Form.Label>
//             <Form.Select 
//               name="invite_permission" 
//               value={newGroup.invite_permission}
//               onChange={handleSelectChange}
//             >
//               <option value="admin_only">Admin Only</option>
//               <option value="user">All Members</option>
//             </Form.Select>
//             <Form.Text className="text-muted">
//               Who can invite new members to the group
//             </Form.Text>
//           </Form.Group>
          
//           <div className="d-flex justify-content-end gap-2 mt-4">
//             <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
//               Cancel
//             </Button>
//             <Button 
//               type="submit" 
//               style={{
//                 background: 'linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)',
//                 border: 'none'
//               }}
//               disabled={loading}
//             >
//               {loading ? 'Creating...' : 'Create Group'}
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );

//   return (
//     <>
//     <Header />
//       <Container className='py-4'>
//         <div className='d-flex justify-content-between align-items-center mb-4' style={{ marginTop: '3.5rem' }}>  
//           <h1 className='fw-bold'>Groups</h1>
//           <InputGroup style={{ width: '300px' }}>
//             <InputGroup.Text className='bg-white border-end-0'>
//               <Search />
//             </InputGroup.Text>
//             <Form.Control
//               placeholder='Search Groups...'
//               className='border-start-0'
//               style={{ boxShadow: 'none' }}
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </InputGroup>
//         </div>
        
//         <Nav className='mb-4'>
//           {['all', 'my'].map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 style={{
//                   backgroundColor:
//                     activeTab === tab ? '#B8529E' : 'transparent',
//                   color: activeTab === tab ? 'white' : '#6c757d',
//                   borderRadius: '50px',
//                   padding: '8px 16px',
//                   transition: 'background-color 0.3s ease',
//                 }}
//               >
//                 {tab === 'all' ? 'All Groups' : 'My Groups'}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//           <Nav.Item>
//             <Nav.Link
//               onClick={() => setShowCreateModal(true)}
//               style={{
//                 backgroundColor: 'transparent',
//                 color: '#6c757d',
//                 borderRadius: '50px',
//                 padding: '8px 16px',
//                 transition: 'background-color 0.3s ease',
//               }}
//             >
//               Create a Group
//             </Nav.Link>
//           </Nav.Item>
//         </Nav>

//         <div className='d-flex justify-content-between align-items-center mb-4'>
//           <p className='text-muted mb-0'>
//             Showing {filteredGroups.length} groups
//           </p>
//           <div className='d-flex gap-2'>
//             <Dropdown>
//               <Dropdown.Toggle
//                 variant='outline-secondary'
//                 className='d-flex align-items-center gap-2'
//               >
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {['Recently Active', 'Most Members', 'Alphabetical'].map(
//                   (option) => (
//                     <Dropdown.Item
//                       key={option}
//                       onClick={() => setSortBy(option)}
//                     >
//                       {option}
//                     </Dropdown.Item>
//                   )
//                 )}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className='btn-group'>
//               <Button
//                 style={{
//                   backgroundColor:
//                     viewMode === 'grid' ? '#B8529E' : 'transparent',
//                   borderColor: '#B8529E',
//                   color: viewMode === 'grid' ? 'white' : '#B8529E',
//                 }}
//                 onClick={() => setViewMode('grid')}
//                 className='d-flex align-items-center justify-content-center'
//               >
//                 <Grid3x3 />
//               </Button>

//               <Button
//                 style={{
//                   backgroundColor:
//                     viewMode === 'list' ? '#B8529E' : 'transparent',
//                   borderColor: '#B8529E',
//                   color: viewMode === 'list' ? 'white' : '#B8529E',
//                 }}
//                 onClick={() => setViewMode('list')}
//                 className='d-flex align-items-center justify-content-center'
//               >
//                 <List />
//               </Button>
//             </div>
//           </div>
//         </div>
        
//         {loading ? (
//           <div className='text-center my-5'>
//             <Spinner animation='border' variant='primary' />
//             <p className='mt-2'>Loading groups...</p>
//           </div>
//         ) : (
//           <Row>
//             {filteredGroups.length > 0 ? (
//               filteredGroups.map((group) => (
//                 <Col md={6} lg={4} className='mb-4' key={group.id}>
//                   {renderGroupCard(group)}
//                 </Col>
//               ))
//             ) : (
//               <div className='col-12 text-center py-5'>
//                 <img
//                   src='https://cdn-icons-png.flaticon.com/512/4076/4076478.png'
//                   alt='No groups'
//                   style={{ width: '150px', opacity: 0.7, marginBottom: '20px' }}
//                 />
//                 <h4 className='text-muted'>No groups found</h4>
//                 <p className='text-muted mb-4'>
//                   {activeTab === 'my' 
//                     ? "You haven't joined any groups yet." 
//                     : "Be the first to create a group!"}
//                 </p>
//                 <Button
//                   variant='primary'
//                   onClick={() => setShowCreateModal(true)}
//                   style={{
//                     background:
//                       'linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)',
//                     border: 'none',
//                     padding: '10px 25px',
//                     borderRadius: '25px',
//                     fontWeight: '500',
//                   }}
//                 >
//                   Create Group
//                 </Button>
//               </div>
//             )}
//           </Row>
//         )}
//       </Container>
      
//       {/* Create Group Modal */}
//       {renderCreateGroupModal()}
//     </>
//   );
// }

// // For testing in Node.js environment
// if (typeof window === 'undefined') {
//   console.log('GroupsPage component created successfully');
//   console.log('This component includes:');
//   console.log('1. API integration for creating groups');
//   console.log('2. API integration for fetching user\'s groups');
//   console.log('3. Group listing with grid/list view options');
//   console.log('4. Group joining functionality');
//   console.log('5. Sorting and filtering capabilities');
// }

// export default GroupsPage;
"use client"

// import { useState, useEffect } from "react"
// import axios from "axios"
// import { useNavigate } from "react-router-dom"
// import { Container, InputGroup, Form, Button, Card, Nav, Row, Col, Dropdown, Modal } from "react-bootstrap"
// import { Search, Grid3x3, List } from "react-bootstrap-icons"
// import Swal from "sweetalert2"
// import Header from "../Components/Header"
// import { motion } from "framer-motion"

// // Main component
// function GroupsPage() {
//   const [activeTab, setActiveTab] = useState("all")
//   const [viewMode, setViewMode] = useState("grid")
//   const [sortBy, setSortBy] = useState("Most Members")
//   const [groups, setGroups] = useState([])
//   const [myGroups, setMyGroups] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [searchTerm, setSearchTerm] = useState("")
//   const [showCreateModal, setShowCreateModal] = useState(false)
//   const [pendingJoinRequests, setPendingJoinRequests] = useState([])

//   // Form state for creating a group
//   const [newGroup, setNewGroup] = useState({
//     name: "",
//     description: "",
//     privacy: "public",
//     is_active: true,
//     post_permission: "admin_only",
//     invite_permission: "user",
//   })

//   const navigate = useNavigate()
//   const token = localStorage.getItem("jwttoken")
//   const backendURL = "https://kaasbackend.vetrinahealthcare.com"

//   // Fetch all groups
//   useEffect(() => {
//     if (activeTab === "all") {
//       setLoading(true)
//       axios
//         .get(`${backendURL}/socialapp/groups/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           const fetchedGroups = response.data
//           // Sort groups by most members first
//           fetchedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0))
//           setGroups(fetchedGroups)
//         })
//         .catch((error) => {
//           console.error("Error fetching groups:", error)
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Failed to load groups. Please try again later.",
//           })
//         })
//         .finally(() => {
//           setLoading(false)
//         })
//     }
//   }, [token, activeTab])

//   // Fetch my groups
//   useEffect(() => {
//     if (activeTab === "my") {
//       setLoading(true)
//       axios
//         .get(`${backendURL}/socialapp/group_memberships/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           const memberships = response.data

//           // Get the group details for each membership
//           const groupPromises = memberships.map((membership) =>
//             axios.get(`${backendURL}/socialapp/groups/${membership.group}/`, {
//               headers: { Authorization: `Bearer ${token}` },
//             }),
//           )

//           Promise.all(groupPromises)
//             .then((groupResponses) => {
//               const myGroupsData = groupResponses.map((res) => ({
//                 ...res.data,
//                 is_connected: true, // Mark as already joined
//               }))

//               // Sort by the selected criteria
//               sortGroups(myGroupsData, sortBy)
//               setMyGroups(myGroupsData)
//             })
//             .catch((error) => {
//               console.error("Error fetching group details:", error)
//             })
//             .finally(() => {
//               setLoading(false)
//             })
//         })
//         .catch((error) => {
//           console.error("Error fetching group memberships:", error)
//           setLoading(false)
//         })
//     }
//   }, [token, activeTab])

//   // Sort groups when sort criteria changes
//   useEffect(() => {
//     if (activeTab === "all") {
//       sortGroups([...groups], sortBy)
//     } else if (activeTab === "my") {
//       sortGroups([...myGroups], sortBy)
//     }
//   }, [sortBy])

//   // Function to sort groups based on criteria
//   const sortGroups = (groupsToSort, criteria) => {
//     const sortedGroups = [...groupsToSort]

//     if (criteria === "Recently Active") {
//       sortedGroups.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//     } else if (criteria === "Most Members") {
//       sortedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0))
//     } else if (criteria === "Alphabetical") {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name))
//     }

//     if (activeTab === "all") {
//       setGroups(sortedGroups)
//     } else if (activeTab === "my") {
//       setMyGroups(sortedGroups)
//     }
//   }

//   // Handle group click to navigate to group details
//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`)
//   }

//   // Handle joining a group
//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: "info",
//         title: "You're already a member!",
//         text: "You have already joined this group.",
//       })
//       return
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]) // Set to pending

//     axios
//       .post(`${backendURL}/socialapp/groups/${groupId}/join/`, {}, { headers: { Authorization: `Bearer ${token}` } })
//       .then(() => {
//         Swal.fire({
//           icon: "success",
//           title: "Join Request Submitted!",
//           text: "Your request has been sent. Waiting for approval.",
//         })

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) => (group.id === groupId ? { ...group, is_pending: true } : group)),
//         )
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)) // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: "info",
//             title: "You're already a member!",
//             text: "You have already joined this group.",
//           })
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Something went wrong while joining the group.",
//           })
//         }
//         console.error("Error joining group:", error)
//       })
//   }

//   // Handle input change for create group form
//   const handleInputChange = (e) => {
//     const { name, value } = e.target
//     setNewGroup({
//       ...newGroup,
//       [name]: value,
//     })
//   }

//   // Handle select change for create group form
//   const handleSelectChange = (e) => {
//     const { name, value } = e.target
//     setNewGroup({
//       ...newGroup,
//       [name]: value,
//     })
//   }

//   // Create a new group
//   const handleCreateGroup = (e) => {
//     e.preventDefault()
//     setLoading(true)

//     // Get user info from localStorage or another source
//     const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {
//       first_name: "User",
//       last_name: "Name",
//       email: "user@example.com",
//       profile_pic: "",
//     }

//     const payload = {
//       created_by: {
//         first_name: userInfo.first_name,
//         last_name: userInfo.last_name,
//         email: userInfo.email,
//         profile_pic: userInfo.profile_pic || "",
//       },
//       ...newGroup,
//     }

//     axios
//       .post(`${backendURL}/socialapp/groups/`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         Swal.fire({
//           icon: "success",
//           title: "Group Created!",
//           text: "Your group has been created successfully.",
//         })

//         // Add the new group to the groups list
//         setGroups((prevGroups) => [response.data, ...prevGroups])

//         // Reset form and close modal
//         setNewGroup({
//           name: "",
//           description: "",
//           privacy: "public",
//           is_active: true,
//           post_permission: "admin_only",
//           invite_permission: "user",
//         })
//         setShowCreateModal(false)

//         // Switch to all groups tab to see the new group
//         setActiveTab("all")
//       })
//       .catch((error) => {
//         console.error("Error creating group:", error)
//         Swal.fire({
//           icon: "error",
//           title: "Error!",
//           text: "Failed to create group. Please try again.",
//         })
//       })
//       .finally(() => {
//         setLoading(false)
//       })
//   }

//   // Filter groups based on search term
//   const filteredGroups =
//     activeTab === "all"
//       ? groups.filter(
//           (group) =>
//             group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             group.description.toLowerCase().includes(searchTerm.toLowerCase()),
//         )
//       : myGroups.filter(
//           (group) =>
//             group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             group.description.toLowerCase().includes(searchTerm.toLowerCase()),
//         )

//   // Group Card Skeleton
//   const GroupCardSkeleton = () => (
//     <Card
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//       }}
//     >
//       {/* Skeleton Cover Image */}
//       <div className="position-relative">
//         <div
//           style={{
//             height: "220px",
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//             borderTopLeftRadius: "20px",
//             borderTopRightRadius: "20px",
//           }}
//         ></div>

//         {/* Skeleton Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2"
//           style={{
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//           }}
//         >
//           <div
//             style={{
//               height: "24px",
//               width: "70%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//               marginBottom: "8px",
//             }}
//           ></div>
//           <div
//             style={{
//               height: "16px",
//               width: "50%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//             }}
//           ></div>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <div
//           style={{
//             height: "50px",
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//             borderRadius: "4px",
//             marginBottom: "15px",
//           }}
//         ></div>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <div
//             style={{
//               height: "24px",
//               width: "40%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//             }}
//           ></div>
//           <div
//             style={{
//               height: "38px",
//               width: "30%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "20px",
//             }}
//           ></div>
//         </div>
//       </Card.Body>
//     </Card>
//   )

//   // Render a group card
//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//         transition: "transform 0.3s ease-in-out",
//         cursor: "pointer",
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className="position-relative">
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo.split("/").pop()}`
//               : "https://placehold.co/400x200?text=Group+Cover&font=roboto" // Default placeholder
//           }
//           alt="Group Cover"
//           className="img-fluid w-100 bg-light"
//           style={{
//             height: "220px",
//             objectFit: "contain", // Ensures full image is visible
//             borderTopLeftRadius: "20px",
//             borderTopRightRadius: "20px",
//             backgroundColor: "#f0f0f0", // optional fallback for transparency
//           }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className="position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white"
//           style={{
//             fontSize: "12px",
//             background: "rgba(0, 0, 0, 0.6)",
//             backdropFilter: "blur(5px)",
//             textTransform: "uppercase",
//           }}
//         >
//           {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white"
//           style={{
//             background: "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)",
//           }}
//         >
//           <h3
//             className="h5 fw-bold mb-1 text-truncate"
//             onClick={(e) => {
//               e.stopPropagation()
//               handleGroupClick(group.id)
//             }}
//             style={{ cursor: "pointer", maxWidth: "90%" }}
//           >
//             {group.name || "Unnamed Group"}
//           </h3>
//           <p className="small mb-0">
//             Created by {group.created_by?.first_name || "Unknown"} {group.created_by?.last_name || ""}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <p className="text-muted text-truncate" style={{ minHeight: "50px", fontSize: "14px" }}>
//           {group.description || "No description available."}
//         </p>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <span className="text-muted fw-semibold" style={{ color: "#B8529E", fontSize: "1.2rem" }}>
//             👥 {group.members?.length || 0} Members
//           </span>
//           {activeTab === "all" && (
//             <Button
//               variant={group.is_connected ? "secondary" : group.is_pending ? "warning" : "primary"}
//               size="sm"
//               className="rounded-pill px-4 shadow-sm"
//               style={{
//                 background: group.is_connected
//                   ? "gray"
//                   : group.is_pending
//                     ? "orange"
//                     : "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                 border: "none",
//               }}
//               disabled={group.is_connected || group.is_pending}
//               onClick={(e) => {
//                 e.stopPropagation()
//                 handleJoinGroup(group.id, group.is_connected)
//               }}
//             >
//               {group.is_connected ? "Joined" : group.is_pending ? "Pending" : "Join"}
//             </Button>
//           )}
//         </div>
//       </Card.Body>
//     </Card>
//   )

//   // Create Group Modal
//   const renderCreateGroupModal = () => (
//     <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} centered size="lg">
//       <Modal.Header closeButton>
//         <Modal.Title>Create a New Group</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form onSubmit={handleCreateGroup}>
//           <Form.Group className="mb-3">
//             <Form.Label>Group Name*</Form.Label>
//             <Form.Control
//               type="text"
//               name="name"
//               value={newGroup.name}
//               onChange={handleInputChange}
//               placeholder="Enter group name"
//               required
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Description</Form.Label>
//             <Form.Control
//               as="textarea"
//               name="description"
//               value={newGroup.description}
//               onChange={handleInputChange}
//               placeholder="Describe your group"
//               rows={3}
//             />
//           </Form.Group>

//           <Row className="mb-3">
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Privacy</Form.Label>
//                 <Form.Select name="privacy" value={newGroup.privacy} onChange={handleSelectChange}>
//                   <option value="public">Public</option>
//                   <option value="private">Private</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">
//                   {newGroup.privacy === "public"
//                     ? "Anyone can see who's in the group and what they post."
//                     : "Only members can see who's in the group and what they post."}
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Post Permission</Form.Label>
//                 <Form.Select name="post_permission" value={newGroup.post_permission} onChange={handleSelectChange}>
//                   <option value="admin_only">Admin Only</option>
//                   <option value="all_members">All Members</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">Who can post content in this group</Form.Text>
//               </Form.Group>
//             </Col>
//           </Row>

//           <Form.Group className="mb-3">
//             <Form.Label>Invite Permission</Form.Label>
//             <Form.Select name="invite_permission" value={newGroup.invite_permission} onChange={handleSelectChange}>
//               <option value="admin_only">Admin Only</option>
//               <option value="user">All Members</option>
//             </Form.Select>
//             <Form.Text className="text-muted">Who can invite new members to the group</Form.Text>
//           </Form.Group>

//           <div className="d-flex justify-content-end gap-2 mt-4">
//             <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
//               Cancel
//             </Button>
//             <Button
//               type="submit"
//               style={{
//                 background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                 border: "none",
//               }}
//               disabled={loading}
//             >
//               {loading ? "Creating..." : "Create Group"}
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   )

//   return (
//     <>
//       <Header />
//       <Container className="py-4">
//         <div className="d-flex justify-content-between align-items-center mb-4" style={{ marginTop: "3.5rem" }}>
//           <h1 className="fw-bold">Groups</h1>
//           <InputGroup style={{ width: "300px" }}>
//             <InputGroup.Text className="bg-white border-end-0">
//               <Search />
//             </InputGroup.Text>
//             <Form.Control
//               placeholder="Search Groups..."
//               className="border-start-0"
//               style={{ boxShadow: "none" }}
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </InputGroup>
//         </div>

//         <Nav className="mb-4">
//           {["all", "my"].map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 style={{
//                   backgroundColor: activeTab === tab ? "#B8529E" : "transparent",
//                   color: activeTab === tab ? "white" : "#6c757d",
//                   borderRadius: "50px",
//                   padding: "8px 16px",
//                   transition: "background-color 0.3s ease",
//                 }}
//               >
//                 {tab === "all" ? "All Groups" : "My Groups"}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//           <Nav.Item>
//             <Nav.Link
//               onClick={() => setShowCreateModal(true)}
//               style={{
//                 backgroundColor: "transparent",
//                 color: "#6c757d",
//                 borderRadius: "50px",
//                 padding: "8px 16px",
//                 transition: "background-color 0.3s ease",
//               }}
//             >
//               Create a Group
//             </Nav.Link>
//           </Nav.Item>
//         </Nav>

//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <p className="text-muted mb-0">Showing {filteredGroups.length} groups</p>
//           <div className="d-flex gap-2">
//             <Dropdown>
//               <Dropdown.Toggle variant="outline-secondary" className="d-flex align-items-center gap-2">
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {["Recently Active", "Most Members", "Alphabetical"].map((option) => (
//                   <Dropdown.Item key={option} onClick={() => setSortBy(option)}>
//                     {option}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className="btn-group">
//               <Button
//                 style={{
//                   backgroundColor: viewMode === "grid" ? "#B8529E" : "transparent",
//                   borderColor: "#B8529E",
//                   color: viewMode === "grid" ? "white" : "#B8529E",
//                 }}
//                 onClick={() => setViewMode("grid")}
//                 className="d-flex align-items-center justify-content-center"
//               >
//                 <Grid3x3 />
//               </Button>

//               <Button
//                 style={{
//                   backgroundColor: viewMode === "list" ? "#B8529E" : "transparent",
//                   borderColor: "#B8529E",
//                   color: viewMode === "list" ? "white" : "#B8529E",
//                 }}
//                 onClick={() => setViewMode("list")}
//                 className="d-flex align-items-center justify-content-center"
//               >
//                 <List />
//               </Button>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
//             <Row>
//               {Array(6)
//                 .fill(0)
//                 .map((_, index) => (
//                   <Col md={6} lg={4} className="mb-4" key={index}>
//                     <GroupCardSkeleton />
//                   </Col>
//                 ))}
//             </Row>
//           </motion.div>
//         ) : (
//           <Row>
//             {filteredGroups.length > 0 ? (
//               filteredGroups.map((group) => (
//                 <Col md={6} lg={4} className="mb-4" key={group.id}>
//                   {renderGroupCard(group)}
//                 </Col>
//               ))
//             ) : (
//               <div className="col-12 text-center py-5">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/512/4076/4076478.png"
//                   alt="No groups"
//                   style={{ width: "150px", opacity: 0.7, marginBottom: "20px" }}
//                 />
//                 <h4 className="text-muted">No groups found</h4>
//                 <p className="text-muted mb-4">
//                   {activeTab === "my" ? "You haven't joined any groups yet." : "Be the first to create a group!"}
//                 </p>
//                 <Button
//                   variant="primary"
//                   onClick={() => setShowCreateModal(true)}
//                   style={{
//                     background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                     border: "none",
//                     padding: "10px 25px",
//                     borderRadius: "25px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Create Group
//                 </Button>
//               </div>
//             )}
//           </Row>
//         )}
//       </Container>

//       {/* Create Group Modal */}
//       {renderCreateGroupModal()}

//       <style jsx>{`
//         @keyframes shimmer {
//           0% { background-position: -200% 0; }
//           100% { background-position: 200% 0; }
//         }
//       `}</style>
//     </>
//   )
// }

// export default GroupsPage


import { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import { Container, InputGroup, Form, Button, Card, Nav, Row, Col, Dropdown, Modal, ListGroup } from "react-bootstrap"
import { Search, Grid3x3, List } from "react-bootstrap-icons"
import Swal from "sweetalert2"
import Header from "../Components/Header"
import { motion } from "framer-motion"
import defaultGroupCover from "../Images/homeImg.jpg"

// Main component
function GroupsPage() {
  const [activeTab, setActiveTab] = useState("all")
  const [viewMode, setViewMode] = useState("grid")
  const [sortBy, setSortBy] = useState("Most Members")
  const [groups, setGroups] = useState([])
  const [myGroups, setMyGroups] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [pendingJoinRequests, setPendingJoinRequests] = useState([])
  const [userRole, setUserRole] = useState("") // State to store user role

  // Form state for creating a group
  const [newGroup, setNewGroup] = useState({
    name: "",
    description: "",
    privacy: "public",
    is_active: true,
    post_permission: "admin_only",
    invite_permission: "user",
  })

  const navigate = useNavigate()
  const token = localStorage.getItem("jwttoken")
  const backendURL = "https://kaasbackend.vetrinahealthcare.com"

  // Fetch user info and determine role
  useEffect(() => {
    const userInfo = localStorage.getItem("role") || {}
    // Check if role exists in userInfo, if not default to "student"
    const role = userInfo || "student"
    setUserRole(role)
  }, [])

  // Check if user can create groups (admin or instructor only)
  const canCreateGroup = () => {
    return userRole === "Admin" || userRole === "Instructor"
  }

  // Fetch all groups
  useEffect(() => {
    if (activeTab === "all") {
      setLoading(true)
      axios
        .get(`${backendURL}/socialapp/groups/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          // Ensure we have an array and remove duplicates
          const fetchedGroups = Array.isArray(response.data) 
            ? response.data.filter((group, index, self) =>
                index === self.findIndex((g) => g.id === group.id)
              )
            : [];
          
          // Sort groups by most members first
          fetchedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));
          setGroups(fetchedGroups);
        })
        .catch((error) => {
          console.error("Error fetching groups:", error)
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Failed to load groups. Please try again later.",
          })
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [token, activeTab])

  // Fetch my groups
// Fetch my groups - FIXED VERSION
useEffect(() => {
  if (activeTab === "my") {
    setLoading(true);
    axios
      .get(`${backendURL}/socialapp/group_memberships/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const memberships = response.data;
        
        // Get unique group IDs from memberships
        const uniqueGroupIds = [...new Set(memberships.map(membership => membership.group))];
        
        // Get the group details for each unique group ID
        const groupPromises = uniqueGroupIds.map((groupId) =>
          axios.get(`${backendURL}/socialapp/groups/${groupId}/`, {
            headers: { Authorization: `Bearer ${token}` },
          })
        );

        Promise.all(groupPromises)
          .then((groupResponses) => {
            // Remove duplicates and mark as connected
            const myGroupsData = groupResponses.map((res) => ({
              ...res.data,
              is_connected: true, // Mark as already joined
            }));

            // Sort by the selected criteria
            sortGroups(myGroupsData, sortBy);
            setMyGroups(myGroupsData);
          })
          .catch((error) => {
            console.error("Error fetching group details:", error);
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch((error) => {
        console.error("Error fetching group memberships:", error);
        setLoading(false);
      });
  }
}, [token, activeTab]);

  // Sort groups when sort criteria changes
  useEffect(() => {
    if (activeTab === "all") {
      sortGroups([...groups], sortBy)
    } else if (activeTab === "my") {
      sortGroups([...myGroups], sortBy)
    }
  }, [sortBy])

  // Function to sort groups based on criteria
  const sortGroups = (groupsToSort, criteria) => {
    const sortedGroups = [...groupsToSort]

    if (criteria === "Recently Active") {
      sortedGroups.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    } else if (criteria === "Most Members") {
      sortedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0))
    } else if (criteria === "Alphabetical") {
      sortedGroups.sort((a, b) => a.name.localeCompare(b.name))
    }

    if (activeTab === "all") {
      setGroups(sortedGroups)
    } else if (activeTab === "my") {
      setMyGroups(sortedGroups)
    }
  }

  // Handle group click to navigate to group details
  const handleGroupClick = (groupId) => {
    navigate(`/group/${groupId}`)
  }

  // Handle joining a group
  const handleJoinGroup = (groupId, isMember) => {
    if (isMember) {
      Swal.fire({
        icon: "info",
        title: "You're already a member!",
        text: "You have already joined this group.",
      })
      return
    }

    setPendingJoinRequests((prev) => [...prev, groupId]) // Set to pending

    axios
      .post(`${backendURL}/socialapp/groups/${groupId}/join/`, {}, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Join Request Submitted!",
          text: "Your request has been sent. Waiting for approval.",
        })

        // Update group state to show 'Pending'
        setGroups((prevGroups) =>
          prevGroups.map((group) => (group.id === groupId ? { ...group, is_pending: true } : group)),
        )
      })
      .catch((error) => {
        setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)) // Remove from pending

        if (error.response?.status === 409) {
          Swal.fire({
            icon: "info",
            title: "You're already a member!",
            text: "You have already joined this group.",
          })
        } else {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Something went wrong while joining the group.",
          })
        }
        console.error("Error joining group:", error)
      })
  }

  // Handle input change for create group form
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewGroup({
      ...newGroup,
      [name]: value,
    })
  }

  // Handle select change for create group form
  const handleSelectChange = (e) => {
    const { name, value } = e.target
    setNewGroup({
      ...newGroup,
      [name]: value,
    })
  }

  // Create a new group
  const handleCreateGroup = (e) => {
    e.preventDefault()
    setLoading(true)

    // Get user info from localStorage or another source
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {
      first_name: "User",
      last_name: "Name",
      email: "user@example.com",
      profile_pic: "",
    }

    const payload = {
      created_by: {
        first_name: userInfo.first_name,
        last_name: userInfo.last_name,
        email: userInfo.email,
        profile_pic: userInfo.profile_pic || "",
      },
      ...newGroup,
    }

    axios
      .post(`${backendURL}/socialapp/groups/`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Group Created!",
          text: "Your group has been created successfully.",
        })

        // Add the new group to the groups list
        setGroups((prevGroups) => [response.data, ...prevGroups])

        // Reset form and close modal
        setNewGroup({
          name: "",
          description: "",
          privacy: "public",
          is_active: true,
          post_permission: "admin_only",
          invite_permission: "user",
        })
        setShowCreateModal(false)

        // Switch to all groups tab to see the new group
        setActiveTab("all")
      })
      .catch((error) => {
        console.error("Error creating group:", error)
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to create group. Please try again.",
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // Function to get cover photo URL
  const getCoverPhotoUrl = (group) => {
    if (!group.cover_photo) {
      return defaultGroupCover;
    }
    
    // If it's already a full URL, use it directly
    if (group.cover_photo.startsWith('http')) {
      return group.cover_photo;
    }
    
    // Otherwise construct the URL
    return group.cover_photo;
  }

  // Filter groups based on search term
  const filteredGroups =
    activeTab === "all"
      ? groups.filter(
          (group) =>
            group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            group.description.toLowerCase().includes(searchTerm.toLowerCase()),
        )
      : myGroups.filter(
          (group) =>
            group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            group.description.toLowerCase().includes(searchTerm.toLowerCase()),
        )

  // Group Card Skeleton
  const GroupCardSkeleton = () => (
    <Card
      className="h-100 border-0 rounded-4 overflow-hidden shadow-lg"
      style={{
        background: "#fff",
        borderRadius: "20px",
      }}
    >
      {/* Skeleton Cover Image */}
      <div className="position-relative">
        <div
          style={{
            height: "220px",
            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.5s infinite",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        ></div>

        {/* Skeleton Gradient Overlay */}
        <div
          className="position-absolute bottom-0 start-0 w-100 px-3 py-2"
          style={{
            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.5s infinite",
          }}
        >
          <div
            style={{
              height: "24px",
              width: "70%",
              background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
              borderRadius: "4px",
              marginBottom: "8px",
            }}
          ></div>
          <div
            style={{
              height: "16px",
              width: "50%",
              background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
              borderRadius: "4px",
            }}
          ></div>
        </div>
      </div>

      {/* Card Body */}
      <Card.Body className="p-4">
        <div
          style={{
            height: "50px",
            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.5s infinite",
            borderRadius: "4px",
            marginBottom: "15px",
          }}
        ></div>

        {/* Members & Join Button */}
        <div className="d-flex justify-content-between align-items-center">
          <div
            style={{
              height: "24px",
              width: "40%",
              background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
              borderRadius: "4px",
            }}
          ></div>
          <div
            style={{
              height: "38px",
              width: "30%",
              background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
              borderRadius: "20px",
            }}
          ></div>
        </div>
      </Card.Body>
    </Card>
  )

  // Render a group card
  const renderGroupCard = (group) => (
    <Card
      key={group.id}
      className="h-100 border-0 rounded-4 overflow-hidden shadow-lg group-card"
      style={{
        background: "#fff",
        borderRadius: "20px",
        transition: "all 0.3s ease-in-out",
        cursor: "pointer",
        transform: "translateY(0)",
      }}
      onClick={() => handleGroupClick(group.id)}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-8px)";
        e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
      }}
    >
      {/* Group Cover Image with Fallback */}
      <div className="position-relative overflow-hidden" style={{ height: "220px" }}>
        <img
          src={getCoverPhotoUrl(group)}
          alt="Group Cover"
          className="img-fluid w-100"
          style={{
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.3s ease",
          }}
          onError={(e) => {
            e.target.src = defaultGroupCover;
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "scale(1)";
          }}
        />
        
        {/* Privacy Badge */}
        <span
          className="position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white fw-semibold"
          style={{
            fontSize: "12px",
            background: group.privacy === "public" 
              ? "linear-gradient(45deg, #28a745, #20c997)" 
              : "linear-gradient(45deg, #dc3545, #fd7e14)",
            backdropFilter: "blur(10px)",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)"
          }}
        >
          {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
        </span>

        {/* Enhanced Gradient Overlay */}
        <div
          className="position-absolute bottom-0 start-0 w-100 px-4 py-3 text-white"
          style={{
            background: "linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.5) 50%, transparent 100%)",
          }}
        >
          <h3
            className="h5 fw-bold mb-2 text-truncate"
            style={{ 
              cursor: "pointer", 
              maxWidth: "90%",
              textShadow: "2px 2px 4px rgba(0,0,0,0.5)"
            }}
          >
            {group.name || "Unnamed Group"}
          </h3>
          <p className="small mb-0 opacity-75">
            Created by {group.created_by?.first_name || "Unknown"} {group.created_by?.last_name || ""}
          </p>
        </div>
      </div>

      {/* Enhanced Card Body */}
      <Card.Body className="p-4 d-flex flex-column">
        <p 
          className="text-muted flex-grow-1 mb-3" 
          style={{ 
            fontSize: "14px",
            lineHeight: "1.5",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden"
          }}
        >
          {group.description || "No description available."}
        </p>

        {/* Enhanced Members & Join Section */}
        <div className="d-flex justify-content-between align-items-center mt-auto">
          <div className="d-flex align-items-center">
            <span 
              className="fw-semibold d-flex align-items-center"
              style={{ 
                color: "#B8529E", 
                fontSize: "1rem",
                background: "rgba(184, 82, 158, 0.1)",
                padding: "6px 12px",
                borderRadius: "20px"
              }}
            >
              👥 {group.members?.length || 0} Members
            </span>
          </div>
          
          {activeTab === "all" && (
            <Button
              variant={group.is_connected ? "secondary" : group.is_pending ? "warning" : "primary"}
              size="sm"
              className="rounded-pill px-4 shadow-sm fw-semibold"
              style={{
                background: group.is_connected
                  ? "linear-gradient(45deg, #6c757d, #495057)"
                  : group.is_pending
                    ? "linear-gradient(45deg, #ffc107, #fd7e14)"
                    : "linear-gradient(45deg, #B8529E, #7D52A0)",
                border: "none",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                transition: "all 0.3s ease",
                minWidth: "90px"
              }}
              disabled={group.is_connected || group.is_pending}
              onClick={(e) => {
                e.stopPropagation()
                handleJoinGroup(group.id, group.is_connected)
              }}
              onMouseEnter={(e) => {
                if (!group.is_connected && !group.is_pending) {
                  e.target.style.transform = "scale(1.05)";
                }
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
              }}
            >
              {group.is_connected ? "✓ Joined" : group.is_pending ? "⏳ Pending" : "➕ Join"}
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  )

  // Render group list item for list view
  const renderGroupListItem = (group) => (
    <ListGroup.Item
      key={group.id}
      className="border-0 rounded-3 mb-3 shadow-sm group-list-item"
      style={{
        background: "#fff",
        cursor: "pointer",
        transition: "all 0.3s ease",
        border: "1px solid #e9ecef"
      }}
      onClick={() => handleGroupClick(group.id)}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateX(8px)";
        e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.1)";
        e.currentTarget.style.borderColor = "#B8529E";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateX(0)";
        e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.05)";
        e.currentTarget.style.borderColor = "#e9ecef";
      }}
    >
      <div className="d-flex align-items-center p-3">
        {/* Group Image */}
        <div className="me-4">
          <img
            src={getCoverPhotoUrl(group)}
            alt="Group"
            className="rounded-3"
            style={{
              width: "80px",
              height: "80px",
              objectFit: "cover"
            }}
            onError={(e) => {
              console.log("List view image failed to load:", getCoverPhotoUrl(group)); // Debug log
              e.target.src = defaultGroupCover;
            }}
          />
        </div>

        {/* Group Details */}
        <div className="flex-grow-1">
          <div className="d-flex align-items-center mb-2">
            <h5 className="mb-0 me-3 fw-bold text-truncate" style={{ color: "#333" }}>
              {group.name || "Unnamed Group"}
            </h5>
            <span
              className="px-3 py-1 rounded-pill text-white fw-semibold small"
              style={{
                background: group.privacy === "public" 
                  ? "linear-gradient(45deg, #28a745, #20c997)" 
                  : "linear-gradient(45deg, #dc3545, #fd7e14)",
                fontSize: "11px"
              }}
            >
              {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
            </span>
          </div>
          
          <p className="text-muted mb-2 small" style={{ lineHeight: "1.4" }}>
            {group.description || "No description available."}
          </p>
          
          <div className="d-flex align-items-center text-muted small">
            <span className="me-4">
              👥 {group.members?.length || 0} Members
            </span>
            <span>
              👤 Created by {group.created_by?.first_name || "Unknown"} {group.created_by?.last_name || ""}
            </span>
          </div>
        </div>

        {/* Join Button for List View */}
        {activeTab === "all" && (
          <div className="ms-3">
            <Button
              variant={group.is_connected ? "secondary" : group.is_pending ? "warning" : "primary"}
              size="sm"
              className="rounded-pill px-4 shadow-sm fw-semibold"
              style={{
                background: group.is_connected
                  ? "linear-gradient(45deg, #6c757d, #495057)"
                  : group.is_pending
                    ? "linear-gradient(45deg, #ffc107, #fd7e14)"
                    : "linear-gradient(45deg, #B8529E, #7D52A0)",
                border: "none",
                minWidth: "100px"
              }}
              disabled={group.is_connected || group.is_pending}
              onClick={(e) => {
                e.stopPropagation()
                handleJoinGroup(group.id, group.is_connected)
              }}
            >
              {group.is_connected ? "✓ Joined" : group.is_pending ? "⏳ Pending" : "➕ Join"}
            </Button>
          </div>
        )}
      </div>
    </ListGroup.Item>
  )

  // Create Group Modal
  const renderCreateGroupModal = () => (
    <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} centered size="lg">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold" style={{ color: "#B8529E" }}>Create a New Group</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 pb-4">
        <Form onSubmit={handleCreateGroup}>
          <Form.Group className="mb-4">
            <Form.Label className="fw-semibold mb-2">Group Name*</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={newGroup.name}
              onChange={handleInputChange}
              placeholder="Enter group name"
              required
              className="rounded-3 p-3"
              style={{ 
                border: "2px solid #e9ecef",
                fontSize: "16px"
              }}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-semibold mb-2">Description</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              value={newGroup.description}
              onChange={handleInputChange}
              placeholder="Describe your group"
              rows={4}
              className="rounded-3 p-3"
              style={{ 
                border: "2px solid #e9ecef",
                fontSize: "16px",
                resize: "none"
              }}
            />
          </Form.Group>

          <Row className="mb-4">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold mb-2">Privacy</Form.Label>
                <Form.Select 
                  name="privacy" 
                  value={newGroup.privacy} 
                  onChange={handleSelectChange}
                  className="rounded-3 p-3"
                  style={{ 
                    border: "2px solid #e9ecef",
                    fontSize: "16px"
                  }}
                >
                  <option value="public">🌍 Public</option>
                  <option value="private">🔒 Private</option>
                </Form.Select>
                <Form.Text className="text-muted mt-2 d-block">
                  {newGroup.privacy === "public"
                    ? "Anyone can see who's in the group and what they post."
                    : "Only members can see who's in the group and what they post."}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold mb-2">Post Permission</Form.Label>
                <Form.Select 
                  name="post_permission" 
                  value={newGroup.post_permission} 
                  onChange={handleSelectChange}
                  className="rounded-3 p-3"
                  style={{ 
                    border: "2px solid #e9ecef",
                    fontSize: "16px"
                  }}
                >
                  <option value="admin_only">👤 Admin Only</option>
                  <option value="all_members">👥 All Members</option>
                </Form.Select>
                <Form.Text className="text-muted mt-2 d-block">Who can post content in this group</Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-4">
            <Form.Label className="fw-semibold mb-2">Invite Permission</Form.Label>
            <Form.Select 
              name="invite_permission" 
              value={newGroup.invite_permission} 
              onChange={handleSelectChange}
              className="rounded-3 p-3"
              style={{ 
                border: "2px solid #e9ecef",
                fontSize: "16px"
              }}
            >
              <option value="admin_only">👤 Admin Only</option>
              <option value="user">👥 All Members</option>
            </Form.Select>
            <Form.Text className="text-muted mt-2 d-block">Who can invite new members to the group</Form.Text>
          </Form.Group>

          <div className="d-flex justify-content-end gap-3 mt-5">
            <Button 
              variant="outline-secondary" 
              onClick={() => setShowCreateModal(false)}
              className="px-4 py-2 rounded-pill fw-semibold"
              style={{ minWidth: "120px" }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="px-4 py-2 rounded-pill fw-semibold"
              style={{
                background: "linear-gradient(45deg, #B8529E, #7D52A0)",
                border: "none",
                minWidth: "120px",
                boxShadow: "0 4px 15px rgba(184, 82, 158, 0.3)"
              }}
              disabled={loading}
            >
              {loading ? "Creating..." : "Create Group"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  )

  return (
    <>
      <Header />
      <Container className="py-4">
        {/* Enhanced Header Section */}
        <div className="d-flex justify-content-between align-items-center mb-5" style={{ marginTop: "3.5rem" }}>
          <div>
            <h1 className="fw-bold mb-2" style={{ color: "#333", fontSize: "2.5rem" }}>
              Groups
            </h1>
            <p className="text-muted mb-0">Connect with communities that share your interests</p>
          </div>
          <InputGroup style={{ width: "350px" }}>
            <InputGroup.Text 
              className="bg-white border-end-0 rounded-start-pill"
              style={{ 
                borderColor: "#e9ecef",
                paddingLeft: "20px"
              }}
            >
              <Search size={18} color="#6c757d" />
            </InputGroup.Text>
            <Form.Control
              placeholder="Search Groups..."
              className="border-start-0 rounded-end-pill"
              style={{ 
                boxShadow: "none",
                borderColor: "#e9ecef",
                paddingLeft: "10px",
                fontSize: "16px"
              }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </div>

        {/* Enhanced Navigation Tabs */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <Nav className="nav-pills">
            {["all", "my"].map((tab) => (
              <Nav.Item key={tab} className="me-2">
                <Nav.Link
                  onClick={() => setActiveTab(tab)}
                  className="rounded-pill px-4 py-2 fw-semibold transition-all"
                  style={{
                    backgroundColor: activeTab === tab ? "#B8529E" : "transparent",
                    color: activeTab === tab ? "white" : "#6c757d",
                    border: activeTab === tab ? "none" : "2px solid #e9ecef",
                    transition: "all 0.3s ease",
                    cursor: "pointer"
                  }}
                  onMouseEnter={(e) => {
                    if (activeTab !== tab) {
                      e.target.style.borderColor = "#B8529E";
                      e.target.style.color = "#B8529E";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== tab) {
                      e.target.style.borderColor = "#e9ecef";
                      e.target.style.color = "#6c757d";
                    }
                  }}
                >
                  {tab === "all" ? "🌐 All Groups" : "👤 My Groups"}
                </Nav.Link>
              </Nav.Item>
            ))}
            {/* Enhanced Create Group Tab */}
            {canCreateGroup() && (
              <Nav.Item>
                <Nav.Link
                  onClick={() => setShowCreateModal(true)}
                  className="rounded-pill px-4 py-2 fw-semibold"
                  style={{
                    backgroundColor: "transparent",
                    color: "#28a745",
                    border: "2px solid #28a745",
                    transition: "all 0.3s ease",
                    cursor: "pointer"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#28a745";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#28a745";
                  }}
                >
                  ➕ Create Group
                </Nav.Link>
              </Nav.Item>
            )}
          </Nav>
        </div>

        {/* Enhanced Controls Section */}
        <div className="d-flex justify-content-between align-items-center mb-4 p-3 rounded-3" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="d-flex align-items-center">
            <span className="text-muted fw-semibold me-3">
              Showing {filteredGroups.length} groups
            </span>
            {filteredGroups.length > 0 && (
              <span className="badge rounded-pill px-3 py-2" style={{ background: "linear-gradient(45deg, #B8529E, #7D52A0)", color: "white" }}>
                {activeTab === "all" ? "All" : "My"} Groups
              </span>
            )}
          </div>
          
          <div className="d-flex gap-3 align-items-center">
            {/* Enhanced Sort Dropdown */}
            <Dropdown>
              <Dropdown.Toggle 
                variant="outline-secondary" 
                className="d-flex align-items-center gap-2 rounded-pill px-4 fw-semibold"
                style={{ 
                  borderColor: "#e9ecef",
                  color: "#6c757d",
                  minWidth: "180px"
                }}
              >
                📊 {sortBy}
              </Dropdown.Toggle>
              <Dropdown.Menu className="rounded-3 shadow-lg border-0" style={{ minWidth: "200px" }}>
                {["Recently Active", "Most Members", "Alphabetical"].map((option) => (
                  <Dropdown.Item 
                    key={option} 
                    onClick={() => setSortBy(option)}
                    className="py-2 px-3 fw-semibold"
                    style={{ 
                      color: sortBy === option ? "#B8529E" : "#6c757d",
                      backgroundColor: sortBy === option ? "rgba(184, 82, 158, 0.1)" : "transparent"
                    }}
                  >
                    {option === "Recently Active" && "🕒 "}
                    {option === "Most Members" && "👥 "}
                    {option === "Alphabetical" && "🔤 "}
                    {option}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Enhanced View Mode Buttons */}
            <div className="btn-group rounded-pill overflow-hidden" style={{ border: "2px solid #e9ecef" }}>
              <Button
                variant="none"
                className="d-flex align-items-center justify-content-center px-3 py-2 fw-semibold"
                style={{
                  backgroundColor: viewMode === "grid" ? "#B8529E" : "transparent",
                  borderColor: "transparent",
                  color: viewMode === "grid" ? "white" : "#6c757d",
                  transition: "all 0.3s ease",
                  minWidth: "50px"
                }}
                onClick={() => setViewMode("grid")}
              >
                <Grid3x3 size={18} />
              </Button>

              <Button
                variant="none"
                className="d-flex align-items-center justify-content-center px-3 py-2 fw-semibold"
                style={{
                  backgroundColor: viewMode === "list" ? "#B8529E" : "transparent",
                  borderColor: "transparent",
                  color: viewMode === "list" ? "white" : "#6c757d",
                  transition: "all 0.3s ease",
                  minWidth: "50px"
                }}
                onClick={() => setViewMode("list")}
              >
                <List size={18} />
              </Button>
            </div>
          </div>
        </div>

        {/* Groups Display */}
        {loading ? (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
            {viewMode === "grid" ? (
              <Row>
                {Array(6)
                  .fill(0)
                  .map((_, index) => (
                    <Col md={6} lg={4} className="mb-4" key={index}>
                      <GroupCardSkeleton />
                    </Col>
                  ))}
              </Row>
            ) : (
              <div>
                {Array(4)
                  .fill(0)
                  .map((_, index) => (
                    <div key={index} className="mb-3">
                      <GroupCardSkeleton />
                    </div>
                  ))}
              </div>
            )}
          </motion.div>
        ) : (
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.5 }}
          >
            {filteredGroups.length > 0 ? (
              viewMode === "grid" ? (
                <Row>
                  {filteredGroups.map((group) => (
                    <Col md={6} lg={4} className="mb-4" key={group.id}>
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, delay: filteredGroups.indexOf(group) * 0.1 }}
                      >
                        {renderGroupCard(group)}
                      </motion.div>
                    </Col>
                  ))}
                </Row>
              ) : (
                <ListGroup variant="flush">
                  {filteredGroups.map((group) => (
                    <motion.div
                      key={group.id}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.3, delay: filteredGroups.indexOf(group) * 0.1 }}
                    >
                      {renderGroupListItem(group)}
                    </motion.div>
                  ))}
                </ListGroup>
              )
            ) : (
              <motion.div 
                className="col-12 text-center py-5"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <div className="mb-4">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/4076/4076478.png"
                    alt="No groups"
                    style={{ 
                      width: "200px", 
                      opacity: 0.6, 
                      marginBottom: "30px",
                      filter: "grayscale(20%)"
                    }}
                  />
                </div>
                <h3 className="fw-bold mb-3" style={{ color: "#6c757d" }}>
                  {searchTerm ? "No groups match your search" : "No groups found"}
                </h3>
                <p className="text-muted mb-4 lead">
                  {activeTab === "my" 
                    ? "You haven't joined any groups yet. Explore and join communities that interest you!" 
                    : searchTerm
                      ? `No groups found for "${searchTerm}". Try adjusting your search terms.`
                      : "No groups are available right now. Be the first to create one!"}
                </p>
                {/* Enhanced Create Group button for no groups state */}
                {canCreateGroup() && !searchTerm && (
                  <Button
                    variant="primary"
                    onClick={() => setShowCreateModal(true)}
                    className="rounded-pill px-5 py-3 fw-bold shadow-lg"
                    style={{
                      background: "linear-gradient(45deg, #B8529E, #7D52A0)",
                      border: "none",
                      fontSize: "18px",
                      boxShadow: "0 8px 25px rgba(184, 82, 158, 0.3)",
                      transition: "all 0.3s ease"
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 12px 35px rgba(184, 82, 158, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 8px 25px rgba(184, 82, 158, 0.3)";
                    }}
                  >
                    🚀 Create Your First Group
                  </Button>
                )}
                {searchTerm && (
                  <Button
                    variant="outline-primary"
                    onClick={() => setSearchTerm("")}
                    className="rounded-pill px-4 py-2 fw-semibold mt-3"
                    style={{ 
                      borderColor: "#B8529E",
                      color: "#B8529E"
                    }}
                  >
                    Clear Search
                  </Button>
                )}
              </motion.div>
            )}
          </motion.div>
        )}
      </Container>

      {/* Enhanced Create Group Modal */}
      {canCreateGroup() && renderCreateGroupModal()}

      {/* Enhanced Styles */}
      <style jsx>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        
        .group-card:hover {
          transform: translateY(-8px) !important;
          box-shadow: 0 20px 40px rgba(0,0,0,0.15) !important;
        }
        
        .group-list-item:hover {
          transform: translateX(8px) !important;
          box-shadow: 0 8px 25px rgba(0,0,0,0.1) !important;
          border-color: #B8529E !important;
        }
        
        .transition-all {
          transition: all 0.3s ease !important;
        }
        
        .nav-pills .nav-link {
          border: 2px solid transparent;
        }
        
        .nav-pills .nav-link:hover {
          background-color: rgba(184, 82, 158, 0.1) !important;
          border-color: #B8529E !important;
          color: #B8529E !important;
        }
        
        .btn-group .btn:first-child {
          border-top-left-radius: 25px !important;
          border-bottom-left-radius: 25px !important;
        }
        
        .btn-group .btn:last-child {
          border-top-right-radius: 25px !important;
          border-bottom-right-radius: 25px !important;
        }
        
        .dropdown-menu {
          animation: slideDown 0.3s ease;
        }
        
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .form-control:focus {
          border-color: #B8529E !important;
          box-shadow: 0 0 0 0.2rem rgba(184, 82, 158, 0.25) !important;
        }
        
        .form-select:focus {
          border-color: #B8529E !important;
          box-shadow: 0 0 0 0.2rem rgba(184, 82, 158, 0.25) !important;
        }
      `}</style>
    </>
  )
}

export default GroupsPage